// App.js
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Wrapper from "./Shared/Wrapper";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Loading from "./components/Loading";

// Lazy load the components
const Home = React.lazy(() => import("./pages/Home"));
const Login = React.lazy(() => import("./pages/Login"));

const App = () => {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Wrapper>
          <Routes>
            <Route
              path="/"
              element={
                <React.Suspense fallback={<Loading />}>
                  <Home />
                </React.Suspense>
              }
            />
            {/* The old standalone schedule page is now the #orari section on
                Home — send anyone with the old link straight there. */}
            <Route path="/orari" element={<Navigate to="/#orari" replace />} />
            <Route
              path="/login"
              element={
                <React.Suspense fallback={<Loading />}>
                  <Login />
                </React.Suspense>
              }
            />
          </Routes>
        </Wrapper>
      </LanguageProvider>
      <Analytics />
      <SpeedInsights />
    </BrowserRouter>
  );
};

export default App;
